



























































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import HolidaysProgramDetails from "../holidays/HolidaysProgramDetails.vue";

import HolidayProgramJson from "../../shared/HolidayProgramJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

export default Vue.extend({
  name: "HolidaysPrograms",
  components: {
    Loading,
    HolidaysProgramDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      showDetails: false,
      detailsMode: "read",
      allPrograms: null as HolidayProgramJson[] | null,
      selectedProgramId: null as number | null,
      selectedProgram: null as HolidayProgramJson | null,
      showOldPrograms: false as boolean,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    loadData() {
      this.loadHolidayPrograms();
    },

    async reloadSelectedProgram() {
      this.selectedProgram = null;
      this.toggleDetails();
      if (this.selectedProgramId != null) {
        try {
          this.allPrograms = await this.restClient.getHolidayPrograms();

          //todo: selectedProgram filtern
          this.openDetails(this.selectedProgram, "read");
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadHolidayPrograms() {
      this.allPrograms = null;
      if (this.restClient != null) {
        try {
          this.allPrograms = await this.restClient.getHolidayPrograms();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    getHolidayProgramStatus(item: HolidayProgramJson) {
      if (item.allowRegistration) {
        let today = new Date();

        if (today < new Date(item.registrationBeginDateTime)) {
          return "Freigegeben und buchbar ab " + DateFormatter.formatDateTime(new Date(item.registrationBeginDateTime));
        } else if (today > new Date(item.registrationEndDateTime)) {
          return "Buchungszeitraum abgelaufen";
        } else {
          return "Freigegeben zur Buchung";
        }
      } else {
        return "Nicht freigegeben";
      }
    },

    openDetails(item: HolidayProgramJson | null, mode: string) {
      if (item != null) {
        this.selectedProgramId = item.ID;
        this.selectedProgram = JSON.parse(JSON.stringify(item));
      } else {
        this.selectedProgramId = null;
        this.selectedProgram = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },

    async duplicateProgram(item: HolidayProgramJson) {
      let newItem: HolidayProgramJson = JSON.parse(JSON.stringify(item));

      this.allPrograms = null;

      newItem.ID = null;
      newItem.title = newItem.title + " Kopie";
      newItem.allowRegistration = false;

      try {
        let duplicatedProgram = await this.restClient.addHolidayProgram(newItem);
      } catch (e) {
        alert(e.message);
      }

      this.loadHolidayPrograms();
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    filteredPrograms(): HolidayProgramJson[] | null {
      if (this.allPrograms != null && !this.showOldPrograms) {
        let today = new Date();
        let filtered = this.allPrograms.filter((i: any) => new Date(i.endDate) > today);

        return filtered;
      } else {
        return this.allPrograms;
      }
    },
  },
});
